import React from 'react';
import PropTypes from 'prop-types';

import BlueButton from 'components/Shared/BlueButton/BlueButton';

var VARIANT_MAP = {
  primary: 'primary',
  secondary: 'secondary',
  destructive: 'danger',
};

var SlateDialogButton = function(props) {
  var variant = props.variant || 'secondary';
  var onClick = props.onClick;
  var disabled = props.disabled || false;
  var loading = props.loading || false;
  var children = props.children;

  return (
    <BlueButton
      variant={VARIANT_MAP[variant] || 'secondary'}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      label={typeof children === 'string' ? children : undefined}
    >
      {typeof children !== 'string' ? children : undefined}
    </BlueButton>
  );
};

SlateDialogButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'destructive']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default SlateDialogButton;
